import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LangModule } from '@seekda/angular-i18n';
import { BmComponentsModule } from '@seekda/bm-components';

import { errorPageInterceptor } from '@bmng/services/http-interceptor/error-page.interceptor';
import { httpInterceptor } from '@bmng/services/http-interceptor/http-interceptor.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { UsersService } from './core/services/users/users.service';
import { ErrorModule } from './pages/global/error/error.module';
import { SharedModule } from './shared/shared.module';

@NgModule({
    declarations: [
        AppComponent,
    ],

    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        CoreModule,
        AppRoutingModule,
        SharedModule,
        BmComponentsModule,
        LangModule,
        ErrorModule,
    ],
    providers: [
        UsersService,
        // errorPageInterceptor first so analytics (httpInterceptor) still logs the raw failure.
        provideHttpClient(withInterceptors([ errorPageInterceptor, httpInterceptor ])),
    ],
    bootstrap: [ AppComponent ],
})
export class AppModule { }
